import React, { useMemo, useState, useEffect } from 'react';
import './Customer.css';
import Logo from './Standard Logo - Horizontal.svg';
import HeadingGif from './gifs/heading.gif';
import CastlesGif from './gifs/bouncy-castles.gif';
import CharactersGif from './gifs/character-visits.gif';
import FollowUsGif from './gifs/follow-us.gif';
import FOOD_HYGINE_RATING from './FHR.svg';
import Category from './components/Category';
import { menuCategories } from './items';

const Customer = () => {
  const gifs = useMemo(() => [CastlesGif, CharactersGif, FollowUsGif], []);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % gifs.length);
    }, 7000);

    return () => clearInterval(interval);
  }, [gifs.length]);

  return (
    <div className="customer-container">
      <header className="customer-header">
        <img className="customer-logo" src={Logo} alt="Blue Duo Catering" />
        <h1 className="customer-title">Blue Duo Mobile Menu</h1>
        <p className="customer-subtitle">Scroll to explore each section</p>
      </header>

      <div className="customer-media">
        <img className="customer-heading-gif" src={HeadingGif} alt="Menu heading" />
        <img className="customer-carousel" src={gifs[index]} alt="Highlights" />
        <img className="customer-rating" src={FOOD_HYGINE_RATING} alt="5 Star Food Hygiene Rating" />
      </div>

      <main className="customer-main">
        {menuCategories.map(({ key, title, products, description }) => (
          <section key={key} className="customer-section">
            <Category title={title} products={products} description={description} />
          </section>
        ))}
      </main>

      <footer className="customer-footer">
        <p>Email: contact@blueduo.events</p>
        <p>Phone: 01352 372235</p>
      </footer>
    </div>
  );
};

export default Customer;
